import { DropDownOption } from './types';

export const STICKINESS_SCORE = ['Low', 'Moderate', 'High', 'Very High'];
export const OfferStates = ['Approved', 'Excluded', 'Flagged', 'InReview'];
export const OFFER_STATES = {
  APPROVED: 'Approved',
  EXCLUDED: 'Excluded',
  FLAGGED: 'Flagged',
  IN_REVIEW: 'InReview',
};
export const UPLOAD_TO_PMS_TYPES = {
  renewal: 'renewal',
  newLeaseUnitType: 'newLease',
  newLeaseUnitCode: 'newLease',
};
export const UPLOAD_TO_PMS_STATUS = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  NOTIFIED: 'NOTIFIED',
  INITIATED: 'INITIATED',
};
export const DASHBOARD_VERSION = `leasemax_${
  process.env.REACT_APP_RANDOM_ID ?? 'new_app'
}`;
export const SummaryTableDataFields = {
  '<2%': '<2%',
  '2-4%': '2-4%',
  '4-6%': '4-6%',
  '6-8%': '6-8%',
  '>8%': '>8%',
};
export const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'June',
  'July',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
export const MODULES = {
  DASHBOARD: { Title: 'dashboard', Path: '/', Name: 'Dashboard' },
  OFFERS: { Title: 'renewals', Path: '/renewals', Name: 'Renewals' },
  REPORTS: { Title: 'reports', Path: '/reports', Name: 'Reports' },
  TENANTS: { Title: 'Tenants', Path: '/tenants', Name: 'Tenants' },
  PORTFOLIO_MANAGER: {
    Title: 'portfolio manager',
    Path: '/portfolio-manager',
    Name: 'Portfolio Manager',
  },
  LEASE_PRICING: {
    Title: 'lease pricing',
    Path: '/lease-pricing',
    Name: 'Lease Pricing',
  },
  NO_WALK_SCORE: {
    Title: 'No Walk Score',
    Path: '/no-walk-score',
    Name: 'No Walk Score',
  },
};

export const ALL = 'ALL';
export const PORTFOLIO = 'portfolio';
export const ALLDropDownOption: DropDownOption = {
  text: ALL,
  value: ALL,
};

export const PORTFOLIO_TYPES = {
  singleFamily: 'SF',
  multiFamily: 'MF',
};
